import { memo } from 'react';
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { useTheme } from '../../theme';
import { formatCompact } from '../../utils';
import { ChartTooltip } from '../ui/ChartTooltip';

const truncate = (text, max = 18) => (text?.length > max ? `${text.slice(0, max - 1)}…` : text);

export const HBarChart = memo(({ data, valueName, valueFormatter, color, highlightFirst = true }) => {
  const { palette } = useTheme();
  const fill = color ?? palette.chart[0];
  const height = Math.max(160, data.length * 40 + 24);

  return (
    <div className='wm-chart' style={{ height }}>
      <ResponsiveContainer width='100%' height='100%'>
        <BarChart data={data} layout='vertical' margin={{ top: 0, right: 16, bottom: 0, left: 0 }}>
          <CartesianGrid horizontal={false} strokeDasharray='3 4' />
          <XAxis type='number' tickFormatter={formatCompact} tickLine={false} axisLine={false} />
          <YAxis
            type='category'
            dataKey='name'
            width={130}
            tickLine={false}
            axisLine={false}
            tickFormatter={v => truncate(v)}
          />
          <Tooltip
            cursor={{ fill: palette.surfaceHover }}
            content={<ChartTooltip valueFormatter={valueFormatter} />}
          />
          <Bar dataKey='value' name={valueName} barSize={18} radius={[0, 5, 5, 0]} animationDuration={600}>
            {data.map((entry, i) => (
              <Cell
                key={entry.name}
                fill={fill}
                fillOpacity={highlightFirst ? Math.max(0.45, 1 - i * 0.12) : 1}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
});
